import { Component } from '@angular/core';

@Component({
  selector: 'app-add-user',
  imports: [],
  templateUrl: './add-user.html',
  styleUrl: './add-user.css',
})
export class AddUser {

}
